import './FiltersMobileSwitchPanel.css';
import React from 'react';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconChevronDown } from '../../../../resources/icons/IconChevronDown.svg';
var commonStyles = "c140phdr";
var ltrStyles = "l7y8ts2";
var rtlStyles = "rmuxv7s";
var FiltersMobileSwitchPanel = function FiltersMobileSwitchPanel(_ref) {
  var filterState = _ref.filterState,
    labelText = _ref.labelText,
    filterPanelLabel = _ref.filterPanelLabel,
    clearAll = _ref.clearAll,
    ctaText = _ref.ctaText,
    togglePanel = _ref.togglePanel,
    panelVisible = _ref.panelVisible,
    clearFilter = _ref.clearFilter,
    triggerFilterFieldOpen = _ref.triggerFilterFieldOpen,
    pleaseSelectText = _ref.pleaseSelectText,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    filtersCount = _ref.filtersCount;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var renderItems = function renderItems(key) {
    return filterState[key].value.map(function (el, index) {
      return filterState[key].value.length - 1 === index ? el : "".concat(el, ", ");
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(withMapModalView ? 'btn btn-secondary' : '', " panel-trigger "),
    onClick: togglePanel
  }, labelText, filtersCount > 0 && withMapModalView && " (".concat(filtersCount, ")")), /*#__PURE__*/React.createElement("div", {
    className: "\n      filters__mobile-items-wrapper\n      ".concat(panelVisible ? 'filters__mobile-items-wrapper--visible' : '', "\n    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: togglePanel
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      maxWidth: '100px',
      textAlign: 'center',
      lineHeight: '1.4'
    }
  }, filterPanelLabel)), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearAll)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__mobile-list"
  }, Object.keys(filterState).map(function (key) {
    return /*#__PURE__*/React.createElement("button", {
      className: "filters__mobile-list-button",
      key: key,
      onClick: function onClick() {
        triggerFilterFieldOpen(key);
      }
    }, /*#__PURE__*/React.createElement("h5", null, filterState[key].title), /*#__PURE__*/React.createElement("p", null, filterState[key].value.length ? renderItems(key) : pleaseSelectText), /*#__PURE__*/React.createElement(IconChevronDown, {
      className: "filters__mobile-list-button-icon"
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer d-lg-none"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: togglePanel
  }, ctaText))));
};
export default FiltersMobileSwitchPanel;